export default function vibrate(duration = 15) {
  if (typeof navigator?.vibrate !== "function") return;
  navigator?.vibrate?.(duration)
}
